import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState, useForm } from 'react-final-form';
import { setError } from '../../../actions';
import { NewSearchPopup } from '../NewSearchPopup';
import { selectSearchFormCurrentCity } from '../../../store/selectors';
import { useCityAndLocationsQuery } from '../../useCityAndLocationsQuery';

interface NewSearchCitiesProps {
  citiesPopupIsOpen: boolean;
  closeCitiesHandler: (wasChanged?: boolean, cityId?: string) => void;
}

export const NewSearchCities = ({
  citiesPopupIsOpen,
  closeCitiesHandler
}: NewSearchCitiesProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();
  const currentCity = useSelector(selectSearchFormCurrentCity);

  const { data, error } = useCityAndLocationsQuery(
    values.city_id || currentCity
  );

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  useEffect(() => {
    if (data?.city) {
      change('cityHasLocations', !!data?.locations.length);
    }
  }, [data]);

  return (
    <NewSearchPopup
      popupTitle={t('search.city_search.title')}
      isOpen={citiesPopupIsOpen}
      data-cy="modal-select-city"
      closePopupHandler={closeCitiesHandler}
      closeHandler={() => closeCitiesHandler(false)}
    />
  );
};
